import { createContext, useContext } from 'react';
import type { Session } from '../core/auth/AuthService';

export interface ShellUser {
  /** Prénom affiché dans la salutation. */
  name: string;
  initial: string;
}

export interface Space {
  id: string;
  label: string;
}

/** Espaces proposés par le sélecteur. Statique : seul l'espace PERSONAL existe côté serveur (CLAUDE.md §5). */
export const SPACES: readonly Space[] = [
  { id: 'family', label: 'Famille Durand' },
  { id: 'personal', label: 'Personnel' },
];

export interface ShellValue {
  user: ShellUser;
  /** `null` en mode démonstration (`?demo`) : aucun compte, données en mémoire. */
  session: Session | null;
  /** Absent en démonstration. */
  onLogout?: () => void;
  space: Space;
  setSpace: (space: Space) => void;
}

export const ShellContext = createContext<ShellValue | null>(null);

export function useShell(): ShellValue {
  const value = useContext(ShellContext);
  if (!value) throw new Error('ShellContext manquant : entourez l’écran de la coque (AppShell).');
  return value;
}

/** Prénom affiché : partie locale de l'e-mail, première lettre en capitale (aucun profil n'existe encore). */
export function userFromEmail(email: string): ShellUser {
  const local = email.split('@')[0]?.split(/[._+-]/)[0]?.trim() ?? '';
  const name = local ? local.charAt(0).toUpperCase() + local.slice(1) : 'vous';
  return { name, initial: name.charAt(0).toUpperCase() };
}
